<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<!--협력사-->
				<el-col :span="3">
					<mk-obj-search-input
						:label="getMessage_('QWCC001341')"
						paramKey="dlrCpnyCd"
						ref="dlrCpnyInput"
						hidden
					/>
				</el-col>
				<el-col :span="3">
					<!--품번-->
					<mk-obj-search-part-no
						:label="getMessage_('QWCC000956')"
						paramKey="causPartNo"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>

				<el-col :span="3">
					<!--실납품사-->
					<mk-obj-search-input :label="getMessage_('QWCC001924')" paramKey="dlvgNm" />
				</el-col>

				<el-col :span="3">
					<!--RO번호-->
					<mk-obj-search-part-no
						:label="getMessage_('QWCC000976')"
						paramKey="roNo"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>
				<el-col :span="3">
					<!--클래임번호-->
					<mk-obj-search-part-no
						:label="getMessage_('QWCC001225')"
						paramKey="clmNo"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>
				<el-col :span="3">
					<!--클레임타입-->
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001566') }}</span>
						<div class="search-option-wrapper__normal">
							<el-select :value="searchParams.ctype" @change="val => changeSelect(val, 'ctype')">
								<el-option :label="getMessage_('SWCC000753')" value=""></el-option>
								<el-option v-for="option in ctypeList" :key="option.commCd" :label="option.commCdName" :value="option.commCd"> </el-option>
							</el-select>
						</div>
					</div>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="3">
					<!--처리단계-->
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC000963') }}</span>
						<div class="search-option-wrapper__normal">
							<el-select :value="searchParams.prcStepGb" @change="val => changeSelect(val, 'prcStepGb')">
								<el-option :label="getMessage_('SWCC000753')" value=""></el-option>
								<el-option v-for="option in prcsStepList" :key="option.commCd" :label="option.commCdName" :value="option.commCd">
								</el-option>
							</el-select>
						</div>
					</div>
				</el-col>

				<el-col :span="3">
					<!--처리결과-->
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC000978') }}</span>
						<div class="search-option-wrapper__normal">
							<el-select :value="searchParams.prcRsltCd" @change="val => changeSelect(val, 'prcRsltCd')">
								<el-option :label="getMessage_('SWCC000753')" value=""></el-option>
								<el-option v-for="option in prcsRsltList" :key="option.commCd" :label="option.commCdName" :value="option.commCd">
								</el-option>
							</el-select>
						</div>
					</div>
				</el-col>
				<el-col :span="3">
					<!--처리결과-->
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001393') }}</span>
						<div class="search-option-wrapper__normal">
							<el-select :value="searchParams.mkobjCd" @change="val => changeSelect(val, 'mkobjCd')">
								<el-option :label="getMessage_('SWCC000753')" value=""></el-option>
								<el-option v-for="option in mkobjList" :key="option.commCd" :label="option.commCdName" :value="option.commCd">
								</el-option>
							</el-select>
						</div>
					</div>
				</el-col>
				<el-col :span="5">
					<sf-group-wrapper :label="getMessage_('QWCC001394')">
						<el-date-picker
							v-model="searchDate1"
							@change="changeSearchSrchMm01"
							type="daterange"
							align="right"
							:start-placeholder="getMessage_('QWCC000920')"
							:end-placeholder="getMessage_('QWCC000954')"
							range-separator="~"
							format="yyyy-MM-dd"
							style="height: 38px"
						/>
					</sf-group-wrapper>
				</el-col>

				<!--변제확정일(클레임 확정월)
				<el-col :span="3">
					<sf-group-wrapper :label="getMessage_('QWCC002032')">
						<el-date-picker
							:value="searchDcsnDdDt"
							@input="val => changeSearchDt(val, 'searchDcsnDdDt')"
							type="month"
							format="yyyy-MM"
							value-format="yyyyMM"
						/>
					</sf-group-wrapper>
				</el-col>-->
				<!--이의제기일
				<el-col :span="3">
					<sf-group-wrapper :label="getMessage_('QWCC001413')">
						<el-date-picker
							:value="searchAplcDdObjDt"
							@input="val => changeSearchDt(val, 'searchAplcDdObjDt')"
							type="month"
							format="yyyy-MM"
							value-format="yyyyMM"
						/>
					</sf-group-wrapper>
				</el-col>
				-->
				<!--이의처리 완료일
				<el-col :span="3">
					<sf-group-wrapper :label="getMessage_('QWCC002031')">
						<el-date-picker
							:value="searchDcsnDdObjDt"
							@input="val => changeSearchDt(val, 'searchDcsnDdObjDt')"
							type="month"
							format="yyyy-MM"
							value-format="yyyyMM"
						/>
					</sf-group-wrapper>
				</el-col>
				-->
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/qlty/MkObj/store/helpers';
import MkObjSearchInput from './MkObjSearchInput.vue';
import MkObjSearchPartNo from './MkObjSearchPartNo.vue';
import qmsUtils from '@/store/qms/api';

export default {
	props: {
		scrId: { type: String, default: '' }
	},

	data() {
		let fromDate = this.$moment().startOf('year').format('YYYY-MM-DD');
		let toDate = this.$moment().format('YYYY-MM-DD');
		return {
			searchDcsnDdDt: '' /*변제확정일*/,
			searchAplcDdObjDt: '' /*이의제기일*/,
			searchDcsnDdObjDt: '' /*이의처리 완료일*/,
			// searchDate1: [new Date(fromDate), new Date(toDate)],
			searchDate1:[],
			fromDate: fromDate,
			toDate: toDate

		};
	},
	components: { MkObjSearchInput, MkObjSearchPartNo },
	computed: {
		...rootComputed,
		...serviceComputed,
		...qmsComputed
	},
	methods: {
		...serviceMethods,
		...rootMethods,
		...qmsMethods,
		changeSelect(val, key) {
			this.setSearchParam_({ key, value: val });
		},
		searchList() {
			if (this.searchDate1 === null) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000008'),
					message: this.getMessage_('QWCC001682')
				}); //필수 검색 값을 확인해주십시오
			} else {
			this.$sf_toggleLoading(true);
			this.getMkObjList_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});}
		},
		changeSearchSrchMm01(data) {
			//console.log('data', data);
			if (data === null || data === '') {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000008'),
					message: this.getMessage_('QWCC001622')
				}); //필수 검색 값입니다.
			} else {
				let from = this.$moment(data[0]).format('YYYY-MM-DD');
				let to = this.$moment(data[1]).format('YYYY-MM-DD');
				let today = this.$moment().format('YYYY-MM-DD');
				let fromDiff = this.$moment(to).diff(this.$moment(from), 'day');
				//이번달<to 검색일자 월
				if (fromDiff > 1096) {
					this.$sf_showMessage({
						icon: 'error',
						title: this.getMessage_('SWCC000008'),
						message: this.getMessage_('QWCC001771')
					}); //3년 이상(1096일) 검색은 불가능합니다
					this.searchDate1[0] = this.fromDate;
					this.searchDate1[1] = this.toDate;
				} else {
					this.selectDate1({ from, to });
					//this.searchList();
				}
			}
		},
		changeSearchDt(val, key) {
			//console.log('val', val);
			let from;
			let to;
			let startDt;
			let endDt;
			if (val) {
				from = this.$moment(val).startOf('month').format('YYYYMMDD');
				to = this.$moment(val).endOf('month').format('YYYYMMDD');
			} else {
				from = '';
				to = '';
			}
			if (key == 'searchDcsnDdDt') {
				this.searchDcsnDdDt = val;
				startDt = 'startDcsnDd';
				endDt = 'endDcsnDd';
			}
			if (key == 'searchAplcDdObjDt') {
				this.searchAplcDdObjDt = val;
				startDt = 'startAplcDdObj';
				endDt = 'endAplcDdObj';
			}
			if (key == 'searchDcsnDdObjDt') {
				this.searchDcsnDdObjDt = val;
				startDt = 'startDcsnDdObj';
				endDt = 'endDcsnDdObj';
			}
			this.setSearchParam_({ key: startDt, value: from });
			this.setSearchParam_({ key: endDt, value: to });
		}
	},
	async created() {
		try {
			await this.getCommCodes_({ key: 'prcsStepList', codeType: 'PRCS_STEP_01' });
			await this.getCommCodes_({ key: 'ctypeList', codeType: 'CLM_TYPE03' });
			await this.getCommCodes_({ key: 'prcsRsltList', codeType: 'PRCS_RSLT_01' });
			await this.getCommCodes_({ key: 'mkobjList', codeType: 'MKOBJ_TYPE_DATE' });

			//협력사여부 변수관리에 협력사가 아닌그룹들을 넣은값을 가지고 가져옴
			//let partNer = await qmsUtils.getPartner();

			let partNer = await this.inclManyUsrGrp_(['MQYCP']); //시장품질 외부사용자(협력사)

			//let noPartNer = this.inclManyUsrGrp_(['MQYAP', 'MQYAP', 'OS']); // 시장품질 관리자관한,일반사용자권한

			//협력사일경우
			if (partNer) {
				let result = await qmsUtils.getDeptNm(this.user.deptCd);

				this.setSearchParam_({ key: 'dlrCpnyCd', value: result.deptNm });

				this.$refs.dlrCpnyInput.showDataProcess(result.deptNm);

				this.setState_({ key: 'readOnlyYn', value: partNer.partnerYn == 'Y' ? true : false });
			}

			//state안에 초기화 되어있는 값을 개터스 함수로 꺼내서 셋팅한다.
			//this.searchDcsnDdDt = this.getStartMonth_; //변제확정일
			//this.searchAplcDdObjDt = this.getStartMonth_; //이의제기일
			//this.searchDcsnDdObjDt = this.getStartMonth_; //이의처리 완료일
			//this.setSearchParam_({ key: 'startDcsnDd', value: this.getStartInitDd_ });
			//this.setSearchParam_({ key: 'endDcsnDd', value: this.getEndInitDd_ });
			//this.setSearchParam_({ key: 'startAplcDdObj', value: this.getStartInitDd_ });
			//this.setSearchParam_({ key: 'endAplcDdObj', value: this.getEndInitDd_ });
			//this.setSearchParam_({ key: 'startDcsnDdObj', value: this.getStartInitDd_ });
			//this.setSearchParam_({ key: 'endDcsnDdObj', value: this.getEndInitDd_ });

			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	}
	
};
</script>

<style></style>
